import React, { useState } from 'react';
import { HardDrive } from 'lucide-react';
import { BlocksView } from './BlocksView';
import { VacuumsView } from './VacuumsView';
import MultiSelectApiDropdownWithAll from '../../../components/MultiSelectApiDropdownWithAll';

interface StorageMaintenanceTabProps {
  activeCluster: string;
  timeRange: string;
  clientId?: string;
  refreshKey?: number;
  dbType?: string;
}

export const StorageMaintenanceTab: React.FC<StorageMaintenanceTabProps> = ({
  activeCluster,
  timeRange,
  clientId,
  refreshKey,
  dbType,
}) => {
  const [selectedDatabases, setSelectedDatabases] = useState<any[]>([{ id: '*', name: 'Select all' }]);

  const dbNames = selectedDatabases
    .map((item) => (typeof item === 'string' ? item : item?.id || item?.name || item?.database))
    .filter((name) => name && name !== '*');

  const databaseParam = dbNames.length > 0 ? dbNames.join(',') : undefined;

  return (
    <div className="space-y-6">
      {/* Top Banner Header with Database Multi-Select Dropdown */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div className="flex items-center gap-2.5">
          <div className="p-1.5 rounded bg-orange-500 text-white shadow-md">
            <HardDrive className="w-4 h-4" />
          </div>
          <div>
            <h2 className="text-lg font-bold text-white tracking-wide">
              Storage & Maintenance
            </h2>
          </div>
        </div>

        {/* Database Multi-Select Dropdown */}
        <div className="w-full sm:w-72">
          <MultiSelectApiDropdownWithAll
            placeholder="Select Databases"
            apiEndpoint="/db_monitor_dashboard/databases"
            additionalParams={{
              cluster_id: activeCluster,
              ...(clientId ? { client_id: clientId } : {}),
            }}
            displayProperty="name"
            idProperty="id"
            searchFields={['name']}
            value={selectedDatabases}
            onChange={(items) => setSelectedDatabases(items)}
            selectAll={true}
            buttonHeight={40}
          />
        </div>
      </div>

      {/* Section 1: Block I/O Activity */}
      <BlocksView
        activeCluster={activeCluster}
        timeRange={timeRange}
        clientId={clientId}
        refreshKey={refreshKey}
        dbType={dbType}
        database={databaseParam}
      />

      {/* Section 2: Vacuums & Maintenance */}
      <div className="border-t border-gray-800 pt-6">
        <VacuumsView
          activeCluster={activeCluster}
          timeRange={timeRange}
          clientId={clientId}
          refreshKey={refreshKey}
          dbType={dbType}
          database={databaseParam}
        />
      </div>
    </div>
  );
};

export default StorageMaintenanceTab;
